import recalls from './recalls';
import recallDetails from './recall';
import dashboard from './dashboard';

export default { recalls, recallDetails, dashboard };



// WEBPACK FOOTER //
// ./src/reducers/index.js